import React from "react";
import { ConfirmModal } from "../../../components/ConfirmModal";
import messages from "../../../../shared/messages";

export interface ConfirmDeleteUserModalProps {
  name: string;
  showModal: boolean;
  toggle: () => void;
  deleteUser: () => void;
}

export const ConfirmDeleteUserModal = ({
  name,
  showModal,
  toggle,
  deleteUser,
}: ConfirmDeleteUserModalProps) => {
  if (!showModal) return null;
  return (
    <ConfirmModal
      show={showModal}
      toggleModal={toggle}
      handleConfirmationClick={deleteUser}
      headingText={messages.DELETE_INTERNAL_USER.confirm.heading}
      paragraphText={messages.DELETE_INTERNAL_USER.confirm.body(name)}
      confirmationButtonText="Yes, delete"
    />
  );
};